import { render, staticRenderFns } from "./CurrencySelectbox.vue?vue&type=template&id=3861925d"
import script from "./CurrencySelectbox.vue?vue&type=script&lang=js"
export * from "./CurrencySelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports